import { $api } from "../generated/client.ts";

type ProductsReturnRatesParams = {
  fromTimestamp: number;
  toTimestamp: number;
  resolution?: string;
  reason?: string;
  country?: string;
  productId?: string;
  variantId?: string;
  catalogId?: string;
  includeAllOrders?: boolean;
};

export default function useProductsReturnRates(
  shopId: string,
  params: ProductsReturnRatesParams,
) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/statistics/products-return-rates",
    {
      params: {
        path: { shopId },
        query: params,
      },
      enabled: !!params.toTimestamp,
    },
  );
}
